import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles'

import theme, { muiTheme } from 'theme'
import store from '@/redux/store'
import { Dialog } from '@mui/material'

import SubscriptionTrialSelection from '../subscription-trial-selection'
import { makeStyles } from '@mui/styles'
import { isMobileScreen } from '@/modules/_helpers/detectMobile'

const useStyles = makeStyles({
  paper: {
    [theme.devices.mobile]: {
      width: '100%',
      height: '100vh',
      maxHeight: '100%',
      margin: 0,
    },
  },
})

// IMPORANT! Needs to use deprecated ReactDOM.render function
// Somehow there is a problem with closing the modal (probably because of our reload stuff in the subscription trial selection)
// TODO: Refactor after ampersand is removed
const openTrialSelectionModal = () => {
  const modalEl = document.getElementById('modalEl')

  const getComponent = () => {
    const [open, setOpen] = useState(true)
    const onClose = () => setOpen(false)
    const classes = useStyles()
    const isMobile = isMobileScreen(theme)

    return (
      <Provider store={store}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={muiTheme}>
            <Dialog
              maxWidth={isMobile}
              disableEscapeKeyDown
              disableBackdropClick
              scroll="paper"
              open={open}
              classes={{ paper: classes.paper }}
            >
              <SubscriptionTrialSelection
                onClose={onClose}
                context='trialSelectNew'
              />
            </Dialog>
          </ThemeProvider>
        </StyledEngineProvider>
      </Provider>
    )
  }

  const renderComponent = () => {
    ReactDOM.render(React.createElement(getComponent), modalEl)
  }

  renderComponent()
}

export default openTrialSelectionModal
